module.exports = __webpack_public_path__ + "img/logo-caisse-epargne-100.de7b5bb7.jpg";